import React from "react";
import Input from "@mui/material/Input";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import { Select } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { ILogModule } from "acr-common-models";

import { Box } from "@mui/material";
import { translate } from "../../../i18n";

interface ILogModulesFilterProps {
  logModules: ILogModule[];
  categoryName: string[];
  onChange?: (event: SelectChangeEvent<string[]>) => void;
  onClose?: (event: React.ChangeEvent<{}>) => void;
}

export class LogModulesFilter extends React.Component<ILogModulesFilterProps> {
  public ITEM_HEIGHT = 52;
  public ITEM_PADDING_TOP = 4;
  public menuProps = {
    PaperProps: {
      style: {
        maxHeight: this.ITEM_HEIGHT * 5.5 + this.ITEM_PADDING_TOP,
        minWidth: 250,
        maxWidth: 250,
      },
    },
  };
  public render(): JSX.Element {
    return (
      <Box display="flex" alignItems="center">
        <FormControl variant="standard">
          <Select
            data-cy="categories-filter"
            multiple
            variant="standard"
            value={this.props.categoryName}
            onChange={this.props.onChange}
            onClose={this.props.onClose}
            input={<Input style={{ color: "rgba(0, 0, 0, 0.54)" }} />}
            displayEmpty={true}
            renderValue={(_) => translate("Categories")}
            MenuProps={this.menuProps}>
            {this.props.logModules.map((logModule, index) => (
              <MenuItem key={logModule.label} value={logModule.title} style={{maxHeight: 30}}>
                <Checkbox
                  data-cy={`category-item-${index}`}
                  color="primary"
                  checked={this.props.categoryName.indexOf(logModule.title) > -1}
                />
                <ListItemText primary={logModule.title} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    );
  }
}
